import { makeStyles, Typography } from "@material-ui/core";
import React from "react";
import { ShowProps, useEditController } from "react-admin";

interface ICustomFormLabel {
  isDefaultTitle?: boolean;
  isNoActions?: boolean;
  isFullName?: boolean;
  property: ShowProps;
  customFieldName?: string;
  customNameWithId?: string;
}

const useStyles = makeStyles({
  root: {
    marginBottom: "-50px",
  },
  noAction: {
    marginBottom: "6px",
  },
});

const CustomFormLabel = (props: ICustomFormLabel) => {
  const classes = useStyles();
  const {
    isDefaultTitle,
    isNoActions,
    isFullName,
    property,
    customFieldName,
    customNameWithId,
  } = props;

  const controllerProps = useEditController(property);
  const { defaultTitle, record } = controllerProps;

  return (
    <Typography
      variant="h4"
      className={isNoActions ? classes.noAction : classes.root}
    >
      {isDefaultTitle
        ? defaultTitle
        : isFullName
        ? `${record?.firstName} ${record?.lastName}`
        : customFieldName
        ? record
          ? record[customFieldName]
          : null
        : customNameWithId
        ? `${customNameWithId} #${record?.id}`
        : record?.name}
    </Typography>
  );
};

export default CustomFormLabel;
